/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { compareWindows } from 'modules/common/ui-controller';

export const TABULAR_TITLE = 'Trend Time Daily Tabular View';
export const TABULAR_CUMULATIVE_TITLE = 'Trend Time Cumulative Tabular View';
export const TABULAR_WEEKLY_TITLE = 'Trend Time Weekly Tabular View';
export const TABULAR_MOVING_AVERAGE_TITLE = 'Trend Time Moving Average Tabular View';
export const TABULAR_PERCENTAGE_TITLE = 'Trend Time Percentage Tabular View';
//
export const TABULAR_HOTEL_TITLE = 'Trend Hotel Daily Tabular View';
export const TABULAR_HOTEL_CUMULATIVE_TITLE = 'Trend Hotel Cumulative Tabular View';
export const TABULAR_HOTEL_WEEKLY_TITLE = 'Trend Hotel Weekly Tabular View';
export const TABULAR_HOTEL_PERCENTAGE_TITLE = 'Trend Hotel Percentage Tabular View';
export const TABULAR_HOTEL_MOVING_AVERAGE_TITLE = 'Trend Hotel Moving Average Tabular View';
//
export const TABULAR_SEGMENT_TITLE = 'Trend Segment Daily Tabular View';
export const TABULAR_SEGMENT_WEEKLY_TITLE = 'Trend Segment Weekly Tabular View';
export const TABULAR_SEGMENT_PERCENTAGE_TITLE = 'Trend Segment Percentage Tabular View';
export const TABULAR_SEGMENT_CUMULATIVE_TITLE = 'Trend Segment Cumulative Tabular View';
export const TABULAR_SEGMENT_MOVING_AVERAGE_TITLE = 'Trend Segment Moving Average Tabular View';

export const TABULAR_SEGMENT_TIME_TITLE = 'Trend Time Segment Daily Tabular View';
export const TABULAR_SEGMENT_TIME_CUMULATIVE_TITLE = 'Trend Time Segment Cumulative Tabular View';
export const TABULAR_SEGMENT_TIME_WEEKLY_TITLE = 'Trend Time Segment Weekly Tabular View';
export const TABULAR_SEGMENT_TIME_HOTEL_TITLE = 'Combined Trend Hotel Segment Tabular View';
export const TABULAR_SEGMENT_TIME_CUMULATIVE_HOTEL_TITLE =
  'Combined Cumulative Trend Hotel Segment Tabular View';
export const TABULAR_SEGMENT_TIME_WEEKLY_HOTEL_TITLE =
  'Combined Weekly Trend Hotel Segment Tabular View';

export const STAY_DATE_RANGE = 'Stay Date Range';
export const STAY_DATE_COMPARISON = 'Comparison';
export const BOOKING_DATE_RANGE = 'Booking Date Range';
export const BOOKING_DATE_COMPARISON = 'Comparison';
export const SELECTED_CURRENCY = 'Selected Currency';
export const CURRENCY_COMPARISON = 'Comparison';
export const PMS_SYNC = 'PMS Sync';
export const NORMALIZATION = 'Normalization';

export const GROUP_A_NAME = 'Group A';
export const GROUP_B_NAME = 'Group B';

export const COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_daily',
  },
];

export const BREAKDOWN_LIST_GETTER_COLUMNS = [
  {
    table: 'measures',
    columns: 'breakdownlistGetter',
  },
];

export const FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_daily_forecast',
  },
];

export const CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_cumulative',
  },
];

export const FORECAST_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_cumulative_forecast',
  },
];

export const WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_weekly',
  },
];

export const WEEKLY_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_weekly_forecast',
  },
];

export const MOVING_AVERAGE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_moving_avg',
  },
];

export const PERCENTAGE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_percentage',
  },
];

export const HOTEL_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_daily',
  },
];

export const HOTEL_W_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_daily_forecast',
  },
];

export const HOTEL_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_weekly',
  },
];

export const HOTEL_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_cumulative',
  },
];

export const HOTEL_FORECAST_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_cumulative_forecast',
  },
];

export const HOTEL_MOVING_AVERAGE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_moving_avg',
  },
];

export const HOTEL_PERCENTAGE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_precentage',
  },
];

export const HOTEL_WEEKLY_FORECAST_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_weekly_forecast',
  },
];

export const SEGMENT_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_daily',
  },
];

export const SEGMENT_CUMULATIVE_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_cumulative',
  },
];

export const SEGMENT_GROUP_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_daily_cm_gp',
  },
];
export const SEGMENT_CUMULATIVE_GROUP_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_cumulative_cm_gp',
  },
];

export const SEGMENT_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_weekly',
  },
];

export const SEGMENT_GROUP_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_weekly_cm_gp',
  },
];
export const SEGMENT_MOVING_AVERAGE_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_moving_avg',
  },
];
export const SEGMENT_MOVING_AVERAGE_GROUP_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_moving_avg_cm_gp',
  },
];

export const SEGMENT_PERCENTAGE_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_percentage',
  },
];

export const SEGMENT_PERCENTAGE_GROUP_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_segment_percentage_cm_gp',
  },
];

export const TIME_SEGMENT_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_segment_daily',
  },
];

export const TIME_SEGMENT_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_segment_weekly',
  },
];

export const TIME_SEGMENT_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_time_segment_cumulative',
  },
];

export const HOTEL_SEGMENT_DAILY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_segment_daily',
  },
];

export const HOTEL_SEGMENT_WEEKLY_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_segment_weekly',
  },
];

export const HOTEL_SEGMENT_CUMULATIVE_COLUMNS = [
  {
    table: 'measures',
    columns: 'trend_hotel_segment_cumulative',
  },
];

export const TREND_CUMULATIVE_TABLE_COLUMNS = [
  {
    id: 'metric',
    label: 'Metric',
    children: [{ id: 'StayDate', label: 'Date', type: 'string', width: 150 }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'cum_room_nights_selected', label: 'Selection', type: 'number', width: 120 },
      { id: 'cum_room_nights_comparison', label: 'Comparison', type: 'number', width: 130 },
      {
        id: 'cum_room_nights_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
      { id: 'forecast_rooms', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'cum_total_revenue_selected', label: 'Selection', type: 'number', width: 150 },
      {
        id: 'cum_total_revenue_comparison',
        label: 'Comparison',
        type: 'number',
        width: 150,
      },
      {
        id: 'cum_total_revenue_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
      { id: 'forecast_revenue', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cum_cancellation_selected', label: 'Selection', type: 'number', width: 150 },
      {
        id: 'cum_cancellation_comparison',
        label: 'Comparison',
        type: 'number',
        width: 150,
      },
      {
        id: 'cum_cancellation_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
    ],
  },
];

export const TREND_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_CUMULATIVE_FORECAST_TABLE_COLUMNS = [
  {
    id: 'metric',
    label: 'Metric',
    children: [{ id: 'StayDate', label: 'Date', type: 'string', width: 150 }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'cum_room_nights_selected', label: 'Selection', type: 'number', width: 120 },
      { id: 'cum_room_nights_comparison', label: 'Comparison', type: 'number', width: 130 },
      {
        id: 'cum_room_nights_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
      {
        id: 'cum_forecast_rooms',
        label: 'Forecast',
        type: 'string',
        width: 120,
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'cum_total_revenue_selected', label: 'Selection', type: 'number', width: 150 },
      {
        id: 'cum_total_revenue_comparison',
        label: 'Comparison',
        type: 'number',
        width: 150,
      },
      {
        id: 'cum_total_revenue_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
      {
        id: 'cum_forecast_revenue',
        label: 'Forecast',
        type: 'string',
        width: 120,
      },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cum_cancellation_selected', label: 'Selection', type: 'number', width: 150 },
      {
        id: 'cum_cancellation_comparison',
        label: 'Comparison',
        type: 'number',
        width: 150,
      },
      {
        id: 'cum_cancellation_percentage_change',
        label: '% Chg',
        type: 'string',
        width: 120,
      },
    ],
  },
];

export const TREND_WEEKLY_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'day_name', label: 'Day', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'Select.', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'Compar.', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_WEEKLY_FORECAST_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'day_name', label: 'Day', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue', label: 'Forecast', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'Selected', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'Comparison', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_MOVING_AVERAGE_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'date', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_PERCENTAGE_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'date', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'pct_change_rn_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'pct_change_rn_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'pct_change_tr_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'pct_change_tr_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'pct_change_adr_selected', label: 'Selection', type: 'number', align: 'right' },
      { id: 'pct_change_adr_comparison', label: 'Comparison', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_HOTEL_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_HOTEL_CUMULATIVE_TABLE_COLUMNS = (granularity) => [
  {
    id: 'metric',
    label: 'Metric',
    children: [
      {
        id: 'StayDate',
        label: granularity === 'day_name' ? 'Day' : 'Date',
        type: 'string',
        width: 150,
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actuals', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actuals', type: 'number', align: 'right' },
      {
        id: 'room_nights_percentage_change',
        label: '% Change',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_forecast_selected',
        label: 'A Forecast',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_forecast_comparison',
        label: 'B Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actuals', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actuals', type: 'number', align: 'right' },
      {
        id: 'total_revenue_percentage_change',
        label: '% Change',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_forecast_selected',
        label: 'A Forecast',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_forecast_comparison',
        label: 'B Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actuals', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actuals', type: 'number', align: 'right' },
      {
        id: 'cancellation_percentage_change',
        label: '% Change',
        type: 'number',
        align: 'right',
      },
    ],
  },
];

export const TREND_HOTEL_CUMULATIVE_FORECAST_TABLE_COLUMNS = (granularity) => [
  {
    id: 'metric',
    label: 'Metric',
    children: [
      {
        id: 'StayDate',
        label: granularity === 'day_name' ? 'Day' : 'Date',
        type: 'string',
        width: 150,
      },
    ],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actls', type: 'number', align: 'right' },
      {
        id: 'room_nights_percentage_change',
        label: '% Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_forecast_selected',
        label: 'A Forecast',
        type: 'number',
        align: 'right',
      },
      {
        id: 'room_nights_forecast_comparison',
        label: 'B Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actls', type: 'number', align: 'right' },
      {
        id: 'total_revenue_percentage_change',
        label: '% Chg',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_forecast_selected',
        label: 'A Forecast',
        type: 'number',
        align: 'right',
      },
      {
        id: 'total_revenue_forecast_comparison',
        label: 'B Forecast',
        type: 'number',
        align: 'right',
      },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actls', type: 'number', align: 'right' },
      {
        id: 'cancellation_percentage_change',
        label: '% Chg',
        type: 'number',
        align: 'right',
      },
    ],
  },
];

export const TREND_HOTEL_MOVING_AVERAGE_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'date', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ADR_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_HOTEL_PERCENTAGE_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'StayDate', label: 'Date', type: 'date', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'pct_change_rn_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'pct_change_rn_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'pct_change_tr_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'pct_change_tr_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'pct_change_adr_A_Actls', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'pct_change_adr_B_Actls', label: 'B Actls', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_HOTEL_WEEKLY_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'date_name', label: 'Day Name', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TREND_HOTEL_WEEKLY_FORECAST_TABLE_COLUMNS = [
  {
    id: 'date',
    label: 'Metric',

    children: [{ id: 'day_name', label: 'Day Name', type: 'string', align: 'left' }],
  },
  {
    id: 'room_nights',
    label: 'Room Nights',
    children: [
      { id: 'room_nights_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'room_nights_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'room_nights_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_rooms_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'revenue',
    label: 'Revenue',
    children: [
      { id: 'total_revenue_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'total_revenue_percentage_change', label: '% Chg', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelA', label: 'A Fcsts', type: 'number', align: 'right' },
      { id: 'forecast_revenue_hotelB', label: 'B Fcsts', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'adr',
    label: 'ADR',
    children: [
      { id: 'ADR_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ADR_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ADR_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'alos',
    label: 'ALOS',
    children: [
      { id: 'ALOS_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'ALOS_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'ALOS_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'lead_time',
    label: 'Lead Time',
    children: [
      { id: 'LeadTime_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'LeadTime_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
  {
    id: 'cancellation',
    label: 'Cancellation Count',
    children: [
      { id: 'cancellation_selected', label: 'A Actls', type: 'number', align: 'right' },
      { id: 'cancellation_comparison', label: 'B Actls', type: 'number', align: 'right' },
      { id: 'cancellation_percentage_change', label: '% Chg', type: 'number', align: 'right' },
    ],
  },
];

export const TABLE_MEASURES = 'measures';
export const COLUMN_DYNAMIC_MEASURE = 'dynamic_measure';
export const COLUMN_DYNAMIC_BREAKDOWN = 'dynamic_measure_st';

export const STAY_DATE_LOWER = 'dynamic_stayDateFilter_lower';
export const STAY_DATE_UPPER = 'dynamic_stayDateFilter_upper';

export const COMPARE_STAY_DATE_LOWER = 'dynamic_comparisonTimeFilterStayDate_lower';
export const COMPARE_STAY_DATE_UPPER = 'dynamic_comparisonTimeFilterStayDate_upper';

export const BOOKING_DATE_LOWER = 'bookingDateFilter_lower';
export const BOOKING_DATE_UPPER = 'bookingDateFilter_upper';

export const COMPARE_BOOKING_DATE_LOWER = 'comparisonBookingDateFilter_lower';
export const COMPARE_BOOKING_DATE_UPPER = 'comparisonBookingDateFilter_upper';

export const COMPARE_BOOKING_OTB_DATE_LOWER = 'comparisonBookingOTB_lower';
export const COMPARE_BOOKING_OTB_DATE_UPPER = 'comparisonBookingOTB_upper';

export const CURRENCY_FILTER = 'currencyFilter';
export const HOTEL_FILTER = 'hotelFilter';
export const HOTEL_COMP_FILTER = 'hotelComFilter';
export const ALIGNMENT_FILTER = 'Aligned';
export const PMS_FILTER = 'pmsFilter';
export const BREAKDOWN_SCHEMA_FILTER = 'breakDownSchema';
export const BREAKDOWN_LIST_FILTER = 'breakDownList';
export const MOVING_AVERAGE_FILTER = 'maDays';
export const GROUP_A_FILTER = 'breakDownGroupA';
export const GROUP_B_FILTER = 'breakDownGroupB';
export const GROUP_A_NAME_FILTER = 'GroupAName';
export const GROUP_B_NAME_FILTER = 'GroupBName';
export const COMPARISON_WINDOW_FILTER = 'comparison_window';
export const NORMALIZED_FILTER = 'normalized';
export const GRANULARITY_FILTER = 'granularityLevel';

export const BREAKDOWN_MAP = {
  detailed: {
    Channel: 'AssignedChannel',
    MarketSegment: 'marketSegmentCode',
    RateCategory: 'AssignedRateCategory',
    Region: 'AssignedRegion',
    Country: 'AssignedRegion',
  },
  nonDetailed: {
    Channel: 'channel_mapped',
    MarketSegment: 'AssignedMarketSegment',
    RateCategory: 'rateCategoryCode',
    Region: 'region_cleaned',
    Country: 'AssignedRegion',
  },
};

export const COMPARE_WINDOW_MAP = {
  [compareWindows.py]: 'PreviousYear',
  [compareWindows.pm]: 'PreviousMonth',
  [compareWindows.pw]: 'PreviousWeek',
  [compareWindows.otb]: 'OTB',
  [compareWindows.cus]: 'Custom',
};
